  // Select All functionality
  function initSelectAll() {
    const container = document.querySelector('.multiple-selections');
    if (!container) return false;
  
    const selectAll = container.querySelector(
      'input[type="checkbox"][value="Select All"]'
    );
    
    if (!selectAll) return false;
    
    // Prevent multiple initializations
    if (selectAll.hasAttribute('data-select-all-initialized')) return true;
    selectAll.setAttribute('data-select-all-initialized', 'true');
  
    const checkboxes = container.querySelectorAll(
      'input[type="checkbox"]:not([value="Select All"])'
    );
  
    // When Select All is clicked
    selectAll.addEventListener('change', function () {
      checkboxes.forEach(cb => {
        cb.checked = selectAll.checked;
        if (selectAll.checked) {
          cb.setAttribute('checked', 'checked');
        } else {
          cb.removeAttribute('checked');
        }
      });
    });
  
    // If any checkbox is unchecked, uncheck Select All
    checkboxes.forEach(cb => {
      cb.addEventListener('change', function () {
        if (!cb.checked) {
          selectAll.checked = false;
          selectAll.removeAttribute('checked');
        } else {
          // If all are checked, auto-check Select All
          const allChecked = Array.from(checkboxes).every(c => c.checked);
          selectAll.checked = allChecked;
          if (allChecked) {
            selectAll.setAttribute('checked', 'checked');
          } else {
            selectAll.removeAttribute('checked');
          }
        }
      });
    });
    
    return true; // Return true to indicate successful initialization
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectAll);
  } else {
    initSelectAll();
  }
  
  // Watch for dynamically loaded content (Globo form builder loads asynchronously)
  // Use MutationObserver to detect when form elements are added to the DOM
  var observer = new MutationObserver(function(mutations) {
    // Check if form elements are now available and initialize
    // Disconnect observer once initialization is successful
    if (initSelectAll()) {
      observer.disconnect();
    }
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Fallback: stop observing after 10 seconds to avoid memory leaks
  // (in case form never loads or initialization fails)
  setTimeout(function() {
    observer.disconnect();
  }, 10000);
  